var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgWatchSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#8e8d9c"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 1C18.8 1 24 6.2 24 12.5S18.8 24 12.5 24 1 18.8 1 12.5 6.2 1 12.5 1m0-1C5.6 0 0 5.6 0 12.5S5.6 25 12.5 25 25 19.4 25 12.5 19.4 0 12.5 0z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M9 7s.1 0 .1.1l9.3 5.3.1.1s-.1 0-.1.1l-9.3 5.3s-.1 0-.1.1V7.2 7m-.1-1c-.5 0-.9.4-.9 1.2v10.7c0 .7.4 1.1.9 1.1.2 0 .5-.1.7-.2l9.3-5.3c.9-.5.9-1.4 0-1.9L9.6 6.2c-.2-.1-.5-.2-.7-.2z"
  }))));
}
export default SvgWatchSelected;